export const CURRENT_LOCATION = "CURRENT_LOCATION";
